import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setProductLoading, setSelectedProduct, setProductError } from "../../repository/slice";
import { IProduct } from "../../types/IProduct";

function* getProductByIdWorker({ payload }: any): SagaIterator {
    try {
        yield put(setProductLoading(true));
        const { data, message, isError }: IResponse<IProduct> = yield call(requester.get, "/api/shop/product/admin/one/" + payload.id);

        if (isError) {
            yield put(setProductError(message));
        } else {
            yield put(setSelectedProduct(data || null));
        }
    } catch (error) {
        console.error("getProductByIdWorker: ", error);
    } finally {
        yield put(setProductLoading(false));
    };
};

export function* getProductByIdWatcher() {
    yield takeLatest("@saga/GET_PRODUCT_BY_ID", getProductByIdWorker);
};